import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  //Typography,
} from "@mui/material";

const SelectField = ({
  name,
  value,
  onChange,
  error,
  helperText,
  label,
  xData = [],
  variant = "standard",
  selectLabel = "",
}) => {
  return (
    // <Select
    //                     name={name}
    //                     value={value}
    //                     onChange={onChange}
    //                     error={error}
    //                     helperText={helperText}
    //                     variant="standard"
    //                     fullWidth
    //                   > {
    //                     xData.length > 0 ?
    //                         xData?.map( ( e,i ) =>
    //                         {
    //                             const keys = Object.keys( e );
    //                             return (
    //                                 <MenuItem key={ "Key" + i }
    //                                     value={ e[ keys[ 0 ] ] }

    //                                 >{ e[ keys[ 1 ] ] }</MenuItem>
    //                             );
    //                         } )
    //                         :
    //                         <MenuItem value={ "" }>none</MenuItem>
    //                 }
    //     </Select>
    <FormControl
      fullWidth
      className={"selectFormContorl"}
      
    >
      <InputLabel // sx={{ left: "-14px" }}
         sx={{
          left: "-14px",
          top: "-7px", // Adjust label position
          "&.MuiInputLabel-shrink": {
            top: "0px", // When a value is selected
          },
          color: "green", // Default label color
          "&.Mui-focused": {
            color: "green", // Label color when focused
          },
        }}
      >
        {selectLabel}
      </InputLabel>
      <Select
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        label={label}
        helperText={helperText}
        variant={variant}
        fullWidth
        sx={{
          "&.MuiSelect-root": {
            color: "green", // Text color
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "2px solid green", // Border color on hover
          },
          "&:before": {
            borderBottom: "1px solid green", // Default underline color
          },
          "&:after": {
            borderBottom: "2px solid green", // Focused underline color
          },
        }}
      >
        {xData.length > 0 ? (
          xData?.map((e, i) => {
            const keys = Object.keys(e);
            return (
              <MenuItem key={"Key" + i} value={e[keys[0]]}>
                {e[keys[1]]}
              </MenuItem>
            );
          })
        ) : (
          <MenuItem value={""}>none</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default SelectField;
